import { render, staticRenderFns } from "./AddSeguradoraPage.vue?vue&type=template&id=20311519&"
import script from "./AddSeguradoraPage.vue?vue&type=script&lang=js&"
export * from "./AddSeguradoraPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports